var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45421 6.5H19.2262L11.9909 11.9264L4.45421 6.5ZM3.5 17.2857V7.66132L11.5618 13.4658L12.0091 13.7878L12.45 13.4571L20.5 7.41964V17.2857C20.5 17.5619 20.2761 17.7857 20 17.7857H4C3.72386 17.7857 3.5 17.5619 3.5 17.2857ZM4 5C2.89543 5 2 5.89543 2 7V17.2857C2 18.3903 2.89543 19.2857 4 19.2857H20C21.1046 19.2857 22 18.3903 22 17.2857V7C22 5.89543 21.1046 5 20 5H4ZM12 10C12.3945 10 12.7143 9.6802 12.7143 9.28571C12.7143 8.89123 12.3945 8.57143 12 8.57143C11.6055 8.57143 11.2857 8.89123 11.2857 9.28571C11.2857 9.6802 11.6055 10 12 10Z",
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail24);
export default __webpack_public_path__ + "static/media/Email-24.cd963ddd.svg";
export { ForwardRef as ReactComponent };